export default "__VITE_ASSET__97afae24__"